import { createBulkMutationHook, createDefaultMutationHook } from "hooks/useMutationHandler";

import { TOGGLE_AI_INTEGRATION } from "./gql";

const useToggleAiIntegration = createDefaultMutationHook(TOGGLE_AI_INTEGRATION);
export const useBulkToggleAiIntegration = createBulkMutationHook(TOGGLE_AI_INTEGRATION);

export default useToggleAiIntegration;
